import type React from "react"
import { useCallback, useEffect, useRef } from "react"

import {
  simulationDeepDiveEventBus,
  type EventListener,
  type EventPayloads,
  type EventType,
} from "./event-bus"

export function useEventBus<T extends EventType>(
  eventType: T,
  listener: EventListener<T>,
  _deps: React.DependencyList = [],
): void {
  const listenerRef = useRef(listener)

  useEffect(() => {
    listenerRef.current = listener
  }, [listener])

  useEffect(() => {
    const unsubscribe = simulationDeepDiveEventBus.subscribe(eventType, ((
      payload: EventPayloads[T],
    ) => listenerRef.current(payload)) as EventListener<T>)
    return unsubscribe
  }, [eventType])
}

export function useEventDispatcher() {
  return useCallback(
    <T extends EventType>(eventType: T, payload: EventPayloads[T]) => {
      simulationDeepDiveEventBus.dispatch(eventType, payload)
    },
    [],
  )
}
